var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBxWalk1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.811,
    height: 27.578,
    viewBox: "0 0 20.811 27.578",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bx-walk",
    transform: "translate(-6.158 -5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_656",
    "data-name": "Path 656",
    d: "M22.358,5.929A2.929,2.929,0,1,1,19.429,3,2.929,2.929,0,0,1,22.358,5.929Z",
    transform: "translate(-0.245 2)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_657",
    "data-name": "Path 657",
    d: "M20.616,18.22a2.934,2.934,0,0,0,1.509,1.153l3.917,1.306.927-2.777L23.052,16.6l-2.435-3.654a2.952,2.952,0,0,0-1.126-.994l-2.1-1.049a2.913,2.913,0,0,0-2.018-.218L10.7,11.848A2.932,2.932,0,0,0,8.785,13.38L6.158,18.636l2.619,1.311L11.4,14.691l3.255-.814L12.018,26.1l-5.38,3.7L8.3,32.214l5.381-3.7a2.914,2.914,0,0,0,1.2-1.794l.758-3.5,3.686,2.765,1.355,6.773,2.872-.576L22.2,25.406a2.929,2.929,0,0,0-1.116-1.766L17.9,21.256l.948-5.689,1.769,2.655Z",
    transform: "translate(0 -0.18)",
    fill: "#666"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxWalk1);
export default __webpack_public_path__ + "static/media/bx-walk1.5469f0a71b29a3d9821e14fbc137446a.svg";
export { ForwardRef as ReactComponent };